import React from "react";
import Error from "../components/error/Error";

const ErrorPage = () => (
    <div>
        <Error />
    </div>
)

export default ErrorPage